import { render } from "./ChatBot.vue?vue&type=template&id=799e1e88"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"

import "./ChatBot.vue?vue&type=style&index=0&id=799e1e88&lang=css"

import exportComponent from "E:\\Cedars Digital\\Amaken_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__